import { Card, Form } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";

const columns = [
  { id: "fullName", label: "Full Name", minWidth: 150, sortable: true },
  { id: "email", label: "Email", minWidth: 170, sortable: true },
  { id: "phone", label: "Phone", minWidth: 150 },
  { id: "companyName", label: "Company", minWidth: 170 },
  { id: "reportTitle", label: "Report Name", minWidth: 200 },
  { id: "purchaseOption", label: "Purchase Option", minWidth: 170 },
  { id: "createdAtFormatted", label: "Created At", minWidth: 180, sortable: true },
];

const IndustryPurchaseList = () => {
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");

  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    fullName: "fullName",
    email: "email",
  };

  useEffect(() => {
    getList(searchRef.current);
  }, [currentPage, sortField, sortOrder]);

  const getList = (keyword: string = "") => {
    setLoading(true);

    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `resources/purchase-now-List?${params.toString()}`,
    })
      .then((res: any) => {
        if (!res?.data?.data) return;

        const formattedRows = res.data.data.map((item: any) => ({
          ...item,
          fullName: item.fullName || "-",
          email: item.email || "-",
          phone: item.phone || "-",
          companyName: item.companyName || "-",
          reportTitle: item.reportTitle || "-",
          purchaseOption: item.purchaseOption,
          createdAtFormatted: item.createdAtFormatted,
        }));

        setList(formattedRows);
        setTotalCount(res.data.pagination.total || 0);
      })
      .catch((err: any) => {
        console.error("Error fetching purchase list:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="events-main">
      <Card className="event-card">
        <div className="d-flex justify-content-between">
          <div className="page-title">Industry Purchase Requests</div>
        </div>

        {/* SEARCH */}
        <div className="row mb-3">
          <div className="col-md-4">
            <Form.Label className="label">Search</Form.Label>
            <Form.Control
              type="text"
              placeholder="Search by name, email, phone, report name"
              value={search}
              onChange={(e) => {
                const value = e.target.value;
                searchRef.current = value;                        
                setSearch(value);
                setCurrentPage(1);
                getList(searchRef.current);
              }}
            />
          </div>
        </div>

        {/* TABLE */}
        <CustomTableSortable
          columns={columns}
          rows={list}
          totalCount={totalCount}
          currentPage={currentPage}
          pageSize={itemsPerPage}
          onPageChange={(page) => setCurrentPage(page)}
          isLoading={loading}
          sortField={uiSortField}
          sortOrder={sortOrder}
          onSortChange={(columnId, order) => {
            setUiSortField(columnId);
            setSortOrder(order);
            const apiField = sortFieldMap[columnId] || "createdAt";
            setSortField(apiField);
            setCurrentPage(1);
            // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
          }}
        />
      </Card>
    </div>
  );
};

export default IndustryPurchaseList;